<template src="./template.html" />

<script>
import essComponentProps from '@/mixins/essComponentProps'
import TrailsExam from '@/components/exams/trails/TrailsExam/TrailsExam.vue'

export default {
  name: 'button_sequence',
  data() {
    return {
      /**
       * @see https://github.com/neurotrack/ExamContracts/blob/master/json/exam_trails_b/perception_data.jsonc
       */
      perception: {
        exam_trial_id: null,
        trial_start_time: null,
        trial_end_time: null,
        metadata: {},
        data: [],
        timeout: false
      }
    }
  },
  mixins: [essComponentProps],
  components: { TrailsExam },
  methods: {
    examStart({ trial_start_time }) {
      this.perception = {
        exam_trial_id: this.trial.exam_trial_id,
        trial_start_time,
        trial_end_time: null,
        metadata: {},
        data: [],
        timeout: false
      }
    },
    examEvent(event) {
      this.perception.data.push({
        type: 'selection',
        value: event
      })
    },
    examFinish({ trial_end_time }) {
      this.perception.trial_end_time = trial_end_time

      // This setTimeout function was set because there are some cases
      // where we need to delay the routing to the "Thank You" page in order
      // to make it possible to send all the data from the LogRocket.
      setTimeout(() => this.handleTrialResponse(this.perception), 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
